(function () {
  if (window.bf26q) return;
  function norm(s) { return String(s || '').toLowerCase().split(' - sold out')[0].trim().replace(/é/g, 'e'); }
  function entry(root, colour) {
    var sc = root && root.querySelector('script[data-bf26q-map]');
    if (!sc) return null;
    var map; try { map = JSON.parse(sc.textContent); } catch (e) { return null; }
    var e = map[norm(colour)] || map['*'];
    return e && e.c ? e : null;
  }
  function apply(root, colour, tapped) {
    var e = entry(root, colour);
    if (!e) return false;
    /* 21 Oct 2026: a tap on the first colour shows that colour's own photo ("o" fields), not the card's opening photo (Always_Display) */
    if (tapped && e.oc) e = { c: e.oc, h: e.oh, f: e.of, hf: e.ohf, s: e.s };
    var img = root.querySelector('img[data-bf26q-img="card"]');
    if (!img) return false;
    img.removeAttribute('srcset');
    img.src = e.c;
    img.dataset.bf26qFit = e.f || 'cover';
    img.style.setProperty('--bf26q-s', e.s || '0.9');
    var hov = root.querySelector('img[data-bf26q-img="hover"]');
    if (hov) {
      if (!e.h) { hov.dataset.empty = '1'; hov.style.display = 'none'; }
      else { delete hov.dataset.empty; hov.style.display = ''; hov.removeAttribute('srcset'); hov.src = e.h; hov.dataset.bf26qFit = e.hf || 'cover'; }
    }
    return true;
  }
  window.bf26q = { apply: apply, norm: norm };
  // R9: touch screens have no hover, a tap goes straight to the product. Do not download hover photos there (cards keep one image, no layout change). Hover photos added later (quick add, load more) are handled by the same sweep.
  var touch = !!(window.matchMedia && matchMedia('(hover: none)').matches);
  function sweepTouch() {
    if (!touch) return;
    Array.prototype.forEach.call(document.querySelectorAll('img[data-bf26q-img="hover"]'), function (h) { h.remove(); });
  }
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || t.type !== 'radio') return;
    var w = t.closest('.card-wrapper');
    if (!w || !w.querySelector('script[data-bf26q-map]')) return;
    var v = t.value;
    apply(w, v, true);
    [0, 150, 600, 1500].forEach(function (ms) { setTimeout(function () { apply(w, v, true); }, ms); });
  });
  /* 21 Oct 2026: tapping the colour that is already selected (the first colour on an untouched card) fires no change event; show its own photo too */
  document.addEventListener('click', function (ev) {
    var l = ev.target && ev.target.closest && ev.target.closest('label[for]');
    var r = l ? document.getElementById(l.getAttribute('for')) : (ev.target && ev.target.type === 'radio' ? ev.target : null);
    if (!r || r.type !== 'radio' || !r.checked) return;
    var w = r.closest('.card-wrapper');
    if (!w || !w.querySelector('script[data-bf26q-map]')) return;
    apply(w, r.value, true);
  }, true);
  // R44b: Build-a-Bundle tiles. The builder swaps the tile image to the variant image when a swatch is picked (and re-renders swatches); put the alt-text / default-first-image pick back. Runs synchronously (no timers, which background tabs throttle) plus delayed backups.
  function sync(card) {
    var on = card.querySelector('.bb-sw.is-on');
    var img = card.querySelector('img[data-bf26q-img="card"]');
    if (!on || !img) return;
    var e = entry(card, on.getAttribute('data-val'));
    if (e && img.getAttribute('src') !== e.c) apply(card, on.getAttribute('data-val'));
  }
  function watch(card) {
    if (card.dataset.bf26qWatch) return;
    card.dataset.bf26qWatch = '1';
    var run = function () { sync(card); [0, 120, 500, 1200].forEach(function (ms) { setTimeout(function () { sync(card); }, ms); }); };
    new MutationObserver(function () { sync(card); run(); }).observe(card, { subtree: true, attributes: true, attributeFilter: ['src', 'class'] });
    card.addEventListener('click', run, true);
  }
  function init() { sweepTouch(); Array.prototype.forEach.call(document.querySelectorAll('[data-bb-card]'), watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (touch) { window.addEventListener('load', sweepTouch); setTimeout(sweepTouch, 1500); }
})();

/* r55 (FX1, F1-03 / Q3-01, P1): set cards. A product card (or its collection quick view, assets/bf26y-r11.js, which clicks the card's own Add) for a SET
   (RKKN Set, Starter Set, glove 3-Pack Sets: the products listed in #rk-set-data, printed by sections/cart-drawer.liquid from the bf26.set_items metafield)
   used to post the set product itself: one 0-piece line at the set variant's own price (RKKN GBP 77 vs 61.60 shown). Its Add now sends the set's
   COMPONENT lines through window.BF26Set.lines() in ONE /cart/add.js, exactly as /pages/sets does (_bf_set, _bf_bundle, the RKKN wash bag),
   renders the drawer from the same response and opens it. bf26s-preset.js and bf26b2-cart.js load on demand. Set product pages keep their own
   handler (bf26s-preset.js, script[data-bf26s]). Rollback: delete this block. */
(function () {
  if (window.__rkSetCards || !window.fetch) return;
  window.__rkSetCards = 1;
  var D;
  function data() {
    if (D !== undefined) return D;
    try { var el = document.getElementById('rk-set-data'); D = el ? JSON.parse(el.textContent) : null; } catch (e) { D = null; }
    return D;
  }
  function find(id) {
    var d = data(), h, s, i;
    if (!d || !d.sets || !id) return null;
    for (h in d.sets) {
      s = d.sets[h];
      for (i = 0; i < s.cfg.variants.length; i++) if (String(s.cfg.variants[i].id) === String(id)) return { handle: h, set: s, variant: s.cfg.variants[i] };
    }
    return null;
  }
  var loading = {};
  function load(src) {
    if (!loading[src]) loading[src] = new Promise(function (ok, no) { var s = document.createElement('script'); s.src = src; s.async = true; s.onload = ok; s.onerror = function () { delete loading[src]; no(new Error('load')); }; document.head.appendChild(s); });
    return loading[src];
  }
  function ready() {
    var a = data().assets || {}, p = [];
    if (!window.BF26Cart && a.cart) p.push(load(a.cart));
    if (!window.BF26Set && a.preset) p.push(load(a.preset));
    return Promise.all(p);
  }
  function note(form, text) {
    var box = form.closest('.card-wrapper, .card, li') || form.parentNode, m = box.querySelector('.rk-setcard-msg');
    if (!m) { m = document.createElement('p'); m.className = 'rk-setcard-msg'; m.setAttribute('role', 'alert'); m.style.cssText = 'margin:6px 0 0;font-family:var(--rk-font-body,var(--font-body-family));font-size:var(--rk-p3,13px);line-height:1.35;color:var(--rk-ink-1,#2B2F27)'; form.parentNode.appendChild(m); }
    m.textContent = text;
    clearTimeout(m.__t); m.__t = setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 6000);
  }
  function add(hit, form) {
    /* 2 Nov 2026: a Pick Your Own pack (items[].choose) needs a colour per pair, which only its product page asks for: open it rather than post the pack's own line (0 pieces) */
    if (hit.set.cfg.items.some(function (i) { return i.choose; })) {
      var a = (form.closest('.card-wrapper, .card, li') || document).querySelector('a[href*="/products/"]');
      location.href = a ? a.href : '/products/' + hit.handle;
      return;
    }
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
    var colour = String(hit.variant.title || '').replace(/ - Sold Out$/i, '');
    var secs = window.RKCart && RKCart.sectionIds ? RKCart.sectionIds() : ['cart-drawer', 'cart-icon-bubble'];
    ready()
      .then(function () { return window.BF26Set.lines(hit.set.cfg, colour); })
      .then(function (items) {
        return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: secs.join(','), sections_url: location.pathname }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && +j.status >= 400)) throw new Error((j && (j.description || j.message)) || ''); return j; }); });
      })
      .then(function (j) {
        if (window.RKCart && RKCart.render) RKCart.render(j.sections); else if (window.BF26Cart) BF26Cart.drawer(j);
        var d = document.querySelector('cart-drawer');
        if (d) d.classList.remove('is-empty');
        if (d && typeof d.open === 'function') { try { d.open(btn); } catch (e) { d.open(); } } else if (window.BF26Cart) BF26Cart.openDrawer();
        if (window.bf26gLadder) window.bf26gLadder.refresh();
      })
      .catch(function (e) {
        var t = e && e.message && !/fetch|network|load/i.test(e.message) ? e.message : 'Sorry, we could not add the set. Please try again.';
        note(form, t);
      })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector || document.querySelector('script[data-bf26s]')) return;
    var id = f.querySelector('[name="id"]'), hit = id && find(id.value);
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    add(hit, f);
  }, true);
  window.RKSetCards = { find: find, data: data };
})();
